import { CohortEnumSchema } from '@eigtech/auth0-types';
import { ContactCornSchema } from '@eigtech/contacts-types';
import { z } from 'zod';
import { NoteCornSchema } from './corn.js';
export const NoteDataSourceSchema = z.enum([
    'CPAP',
    'CSR',
    'Delegate',
    'EmailReceiving',
    'EmailSending',
    'Meetings',
    'Symbility',
    'TPLAP',
    'Verisk',
]);
export const NoteDataSource = NoteDataSourceSchema.enum;
export const NoteUserMetadataSchema = z
    .object({
    licenseNumber: z.string().optional(),
})
    .and(z.record(z.string(), z.string().or(z.number()).or(z.boolean())))
    .optional();
export const NotePublicationTargetSchema = z.enum(['XactAnalysis']).or(z.string());
export const NoteSchema = z.object({
    category: z.string().optional(),
    createdBy: z.string(),
    createdOn: z.string().datetime(),
    dataSource: NoteDataSourceSchema.or(z.string()).optional(),
    entityId: z.string(),
    id: NoteCornSchema,
    /** Undefined means publishable */
    isPublishable: z.boolean().default(true).optional(),
    publicationTargets: NotePublicationTargetSchema.array().optional(),
    publishedFrom: NotePublicationTargetSchema.optional(),
    sourceId: z.string().optional(),
    taggedContacts: ContactCornSchema.array().optional(),
    templateId: z.string().optional(),
    text: z.string(),
    title: z.string().optional(),
    userCohorts: CohortEnumSchema.array(),
    userMetadata: NoteUserMetadataSchema,
});
export const isNoteDataSource = (dataSource) => NoteDataSourceSchema.safeParse(dataSource).success;
